import { parseZone } from "moment";
import { IAppStore } from "../stores/Interfaces";
import { GOTOWKA } from "../constants/values";
import { Declarant } from "../models/Declarant";
import { EDIT_DATA_AFTER_HAND_OVER } from "../constants/authorize";

const canEditDeclarantField = (
  declarant: Declarant,
  store?: IAppStore
): boolean => {
  if (!store) {
    return false;
  }

  const entity = store?.settingsStore.departmentHandOvers.find(
    (item) => item.department_id === declarant.department_id
  );

  if (
    entity &&
    declarant.department_data &&
    declarant.department_data.form_payment === GOTOWKA
  ) {
    const parsedDate = parseZone(declarant.creation_date);

    if (parsedDate && entity.created_at.isSameOrAfter(declarant.created_at)) {
      return store?.userStore.authorize(EDIT_DATA_AFTER_HAND_OVER);
    }

    return true;
  }

  return true;
};

export default canEditDeclarantField;
